<template>
  <div class="d-i-b">
    <div class="btn-group fabric-dropdown">
      <button
        data-toggle="dropdown"
        class="btn btn-info dropdown-toggle btn-sm"
      >
        <span class="caret"></span>
      </button>
      <ul class="dropdown-menu pull-right">
        <li><a class="pointer" @click="showUrgentModal()">Add To Urgent</a></li>
        <li v-if="!isSelectionContainSpecialRequestOrder()">
          <a class="pointer" @click="showWaitingModal()">Add To Waiting</a>
        </li>
        <li v-if="isInWaitingSection">
          <a class="pointer" @click="removeFromWaiting()"
            >Remove from Waiting</a
          >
        </li>
        <li><a class="pointer" @click="remakeShirt()">Remake Shirt</a></li>
        <li><a class="pointer" @click="finishShirt()">Finish Shirt</a></li>
      </ul>
    </div>

    <waiting-info-modal @submit="addToWaiting" />

    <urgent-order-modal @submit="addToUrgent" />
  </div>
</template>

<script>
import Swal from "sweetalert2";
import moment from "moment";
import WaitingInfoModal from "./WaitingInfoModal";
import UrgentOrderModal from "./UrgentOrderModal";

export default {
  components: {
    WaitingInfoModal,
    UrgentOrderModal,
  },
  props: ["data"],
  data() {
    return {
      isInWaitingSection:
        window.location.href.indexOf("/shirt/listings/waiting") > -1,
    };
  },
  methods: {
    getIds() {
      let arrayData = this.data;
      let ids = [];
      arrayData.forEach((val) => {
        ids.push(val.id);
      });
      return ids;
    },
    async sentData(params) {
      try {
        let res = await axios.post("shirt_orders/multiple/action", {
          params: params,
          ids: this.getIds(),
        });
        if (res) {
          toastr.success("success");
          this.$emit("success", 1);
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },

    async addToUrgent() {
      await this.sentData({
        waiting: 0,
        waiting_reason: null,
        waiting_notes: null,
        urgent: 1,
        urgent_reason: $("input[name='urgent_reason']:checked").val(),
        action: "urgent",
      });
      hide_modal("#add-urgent");
    },

    async showUrgentModal() {
      show_modal("#add-urgent");
    },

    async showWaitingModal() {
      show_modal("#add-waiting");
    },
    async addToWaiting(params) {
      await this.sentData({
        waiting: 1,
        waiting_reason: params.waiting_reason,
        waiting_notes: params.waiting_notes,
        action: "waiting",
      });
      hide_modal("#add-waiting");
    },
    async removeFromWaiting() {
      let result = await Swal.fire({
        title: "Are you sure?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Remove from Waiting",
      });
      if (result.value) {
        await this.sentData({
          waiting: 0,
          waiting_reason: null,
          waiting_notes: null,
          action: "waiting",
        });
      }
    },
    async remakeShirt() {
      const { value: value } = await Swal.fire({
        type: "warning",
        title: "Are You Sure",
        showCancelButton: true,
      });
      if (value) {
        await this.sentData({
          remake: 1,
          remake_start: moment().format("YYYY-MM-DD HH:mm:ss"),
        });
      }
    },

    async finishShirt() {
      const { value: value } = await Swal.fire({
        type: "warning",
        title: "Are You Sure",
        showCancelButton: true,
      });
      if (value) {
        await this.sentData({
          shirt_order_status_id: shirtOrderStatus.SENT_TO_GERMANY,
        }); //108 => sent to germany
      }
    },

    isSelectionContainSpecialRequestOrder() {
      return this.data.some(shirtOrder => {
        return shirtOrder.waiting_reason == 'special_request'
      })
    },

    async deleteShirt() {
      const { value: value } = await Swal.fire({
        type: "warning",
        title: "Are You Sure",
        showCancelButton: true,
      });
      if (value) {
        await this.sentData({ soft_delete: 1 });
      }
    },
  }
};
</script>

<style scoped>
[class*="icheck-"] > label {
  color: black;
}
.d-i-b {
  display: inline-block;
}
</style>
